import { ICodeGroupModel, ICommonCd } from 'src/models';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

/* 전체 공통 코드 목록 조회 */
export const getCommonCds = async () => {
  try {
    const url = `/commonCd`;
    const response = await instance.get<TApiResponseData<ICodeGroupModel[]>>(url);

    if (response.data.resultCode === 'S' && response.data.data) {
      return response.data.data;
    }

    return [];
  } catch (error) {
    console.error(error);
  }
};

/* 자식 코드 목록 조회 */
export const getCommonCd = async (cdPid: number) => {
  try {
    const url = `/commonCd/${cdPid}`;
    const response = await instance.get<TApiResponseData<ICommonCd[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
